module.exports = __webpack_public_path__ + "img/illusCorona4.9b7f4664.jpg";